import { css } from '@emotion/css';

const styles = {
  list: css`
    list-style: none;
    margin: 0;
    padding: 0;
  `,
  horizontalPadding: css`
    padding: 0 16px;
  `,
};

export default styles;
